import { render } from "./WhiteboardsAndProjectorsModule.vue?vue&type=template&id=a568ea64&scoped=true"
import script from "./WhiteboardsAndProjectorsModule.vue?vue&type=script&lang=js"
export * from "./WhiteboardsAndProjectorsModule.vue?vue&type=script&lang=js"

import "./WhiteboardsAndProjectorsModule.vue?vue&type=style&index=0&id=a568ea64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a568ea64"

export default script